
import { defineComponent, computed, ref, provide, onMounted } from "vue";
import { useKeycloak, isTokenReady, getToken } from "@baloise/vue-keycloak";

// Components
import Header from "../CAP_VUE_BUNDLE/headerBundle/components/Header.vue";
import Footer from "../CAP_VUE_BUNDLE/footerBundle/components/Footer.vue";

import CartBlockHeader from "@/components/cart/CartBlockHeader.vue";
import ModalDetailItem from "@/components/modal/ModalDetailItem.vue";
import ModalItemPriceOverLimit from "@/components/modal/ModalItemPriceOverLimit.vue";
import PendingSpinnerFullCover from "@/components/global/PendingSpinnerFullCover.vue";
import {
  modalDetailItemIsOpen,
  modalItemPriceOverLimitIsOpen,
} from "@/provideInject/globalKey";
import Contact from "@/components/global/Contact.vue";
import ButtonSite from "@/components/customInput/ButtonSite.vue";
import ApiMyGarage from "@/services/ApiMyGarage";
import { ContactSubjectType } from "@/type/ContactType";
import { RouteName } from "@/constante/RouterConst";

import { router } from "@/router";
import ServiceCreateRoute from "./services/ServiceCreateRoute";
import { usePendingStore } from "@/store/pendingStore";
import { useUserStore } from "./store/userStore";
import { useReturnStore } from "./store/returnStore";
import ServiceMercure from "./services/ServiceMercure";
import { ModelMercureOrderToValidate } from "./type/MercureType";
import notify from "@/services/NotifySite";
import { useI18n } from "vue-i18n";
import { ListIdClientSso } from "./type/MenuSSOType";
import { useGlobalStore } from "./store/globalStore";

export default defineComponent({
  components: {
    Header,
    CartBlockHeader,
    ModalDetailItem,
    ModalItemPriceOverLimit,
    Footer,
    PendingSpinnerFullCover,
    Contact,
    ButtonSite,
  },

  setup() {
    const globalStore = useGlobalStore();
    const { t } = useI18n();
    const pendingStore = usePendingStore();
    const userStore = useUserStore();
    const returnStore = useReturnStore();
    pendingStore.$patch({ firstLoading: true });
    const initIsEnded = ref(false);
    const getFirstLoading = computed(() => {
      return pendingStore.getFirstLoading;
    });
    const getRouterIsPending = computed(() => {
      return pendingStore.getRouterIsPending;
    });

    provide(modalDetailItemIsOpen, ref(false));
    provide(modalItemPriceOverLimitIsOpen, ref(false));
    const modalisOpen = modalDetailItemIsOpen;
    const modalPriceOverLimitIsOpen = modalItemPriceOverLimitIsOpen;

    //chargement et identification keycloak
    const { isAuthenticated, keycloak, isPending, username } = useKeycloak();
    const isLoading = computed(() => keycloak != null && isPending.value);
    const keycloakInstance = computed(() => useKeycloak().keycloak);

    const email = computed(() =>
      undefined === keycloakInstance.value ||
      undefined === keycloakInstance.value.tokenParsed
        ? ""
        : keycloakInstance.value.tokenParsed.email
    );
    const token = computed(() =>
      undefined === keycloakInstance.value ||
      undefined === keycloakInstance.value.token
        ? ""
        : keycloakInstance.value.token
    );

    const user = computed(() => username.value);
    const title = process.env.VUE_APP_TITLE;

    const subject = ref(null as ContactSubjectType[] | null);
    const eventSource = ref(null as null | EventSource);
    const eventOrderToValidateCreate = ref(null as null | EventSource);
    const getMenuSSO = computed(() => {
      return globalStore.getMenuSSO;
    });
    return {
      globalStore,
      getMenuSSO,
      isAuthenticated,
      isLoading,
      initIsEnded,
      user,
      title,
      keycloakInstance,
      email,
      token,
      getRouterIsPending,
      getFirstLoading,
      subject,
      modalisOpen,
      modalPriceOverLimitIsOpen,
      eventSource,
      userStore,
      returnStore,
      pendingStore,
      eventOrderToValidateCreate,
      t,
    };
  },
  async mounted() {
    await isTokenReady();
    const listIdClientSsos = {
      listIdClientSso: Object.keys(this.keycloakInstance.resourceAccess as any),
    } as ListIdClientSso;

    await this.globalStore.setMenuSSO(listIdClientSsos);
    const menuSSO = this.getMenuSSO;

    menuSSO?.ssoSiteInfoMenus.forEach((siteSSO) => {
      if (siteSSO.idClientSso !== process.env.VUE_APP_KEYCLOAK_CLIENT) {
        const newRoute = ServiceCreateRoute.createRoute(siteSSO);
        this.$router.addRoute(newRoute);
        this.$router.replace(this.$router.currentRoute.value.fullPath);
      }
    });
    try {
      await ApiMyGarage.createLogConnect();
      this.subject = await ApiMyGarage.getContactSubject();
      await this.userStore.setUser();
      await this.userStore.setUserTodayPriceOrders();
      this.pendingStore.$patch({ myCartIsPending: true });
      await this.userStore.initCart();
      /**** du customer dans le return store *****/
      if(this.userStore.getUser){
        await this.returnStore.setCustomer(this.userStore.getUser);
      }
      

      /**
       * Abonement au notification concernant les commande en attente de validation
       */
      await this.userStore.getMyIdOrderToValidate();
      if (0 < this.userStore.getIdOrdersWaitingToValidate.length) {
        this.eventSource = ServiceMercure.subscribeOrderToValidate(
          this.userStore.getIdOrdersWaitingToValidate
        );
        this.eventSource.onmessage = async (e) => {
          const mercureOrderToValidate = JSON.parse(
            e.data
          ) as ModelMercureOrderToValidate;
          if (mercureOrderToValidate.updated) {
            notify.mercure(this.t(mercureOrderToValidate.message + ".user"));
          }
        };
      }

      /**
       * Abonnement aux notifications nouvelles commande à valider
       */
      this.eventOrderToValidateCreate =
        ServiceMercure.subscribeOrderToValidateCreate(this.keycloakInstance);
      this.eventOrderToValidateCreate.onmessage = async (e) => {
        const mercureOrderToValidate = JSON.parse(
          e.data
        ) as ModelMercureOrderToValidate;
        notify.mercure(this.t(mercureOrderToValidate.message));
      };
      this.initIsEnded = true;
      this.pendingStore.removeAllPending();
    } catch (error) {
      ApiMyGarage.sendError("Erreur App.vue onMounted");
      this.pendingStore.removeAllPending();
      router.push({ name: RouteName.Error });
    }
  },
  unmounted() {
    if (this.eventSource) {
      this.eventSource.close();
    }
    if (this.eventOrderToValidateCreate) {
      this.eventOrderToValidateCreate.close();
    }
  },
  methods: {
    async logout() {
      if (this.eventSource) {
        this.eventSource.close();
      }
      const token = await getToken();
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + token,
        },
        body: new URLSearchParams({
          id_token_hint: this.keycloakInstance.idToken as string,
        }),
      };
      await fetch(
        process.env.VUE_APP_KEYCLOAK_URL +
          "/realms/" +
          process.env.VUE_APP_KEYCLOAK_REALM +
          "/protocol/openid-connect/logout",
        options
      ).catch(() => window.location.reload());
    },
  },
});
